import { PoolUpdateRequest } from "../../model/poolUpdateRequest";
import { fetchPutJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = PoolUpdateRequest;
export async function putPoolsId(payload: DtoType) {
  try {
    const url = apiUrls.putPoolsId.replace("{{id}}", `${payload.id}`);
    return await fetchPutJSON(url, payload);
  } catch (err) {
    console.error("API Error - putPoolsId:", err);
  }
}
